import { render, staticRenderFns } from "./refund-details.vue?vue&type=template&id=498ac3b5&scoped=true"
import script from "./refund-details.vue?vue&type=script&lang=js"
export * from "./refund-details.vue?vue&type=script&lang=js"
import style0 from "./refund-details.vue?vue&type=style&index=0&id=498ac3b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ac3b5",
  null
  
)

export default component.exports